import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class MossFloor extends Floor {
	static key = "MossFloor";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): MossFloor {
		const f = new MossFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
